import { createAction, props } from '@ngrx/store';

import { ITrackList } from '../../models';

export const trackList = createAction(
  '[ProductList] Track List',
  props<{ payload: ITrackList }>(),
);
